import epResolvers from "src/modules/exam-preparation/offline/graphql/resolvers";
const resolvers = {
    ...epResolvers.fields,
    Query: {
        ...epResolvers.Query,
    },
    Mutation: {
        ...epResolvers.Mutation,
    },
};
export default resolvers;
